var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H9.28571V3.57143C9.28571 1.6 7.68571 0 5.71429 0C3.74286 0 2.14286 1.6 2.14286 3.57143V5H1.42857C0.642857 5 0 5.64286 0 6.42857V13.5714C0 14.3571 0.642857 15 1.42857 15H10C10.7857 15 11.4286 14.3571 11.4286 13.5714V6.42857C11.4286 5.64286 10.7857 5 10 5ZM5.71429 11.4286C4.92857 11.4286 4.28571 10.7857 4.28571 10C4.28571 9.21429 4.92857 8.57143 5.71429 8.57143C6.5 8.57143 7.14286 9.21429 7.14286 10C7.14286 10.7857 6.5 11.4286 5.71429 11.4286ZM3.57143 5V3.57143C3.57143 2.38571 4.52857 1.42857 5.71429 1.42857C6.9 1.42857 7.85714 2.38571 7.85714 3.57143V5H3.57143Z",
    fill: "#064149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ce3ba3ff25506acaaced6ee86941f384.svg";
export { ForwardRef as ReactComponent };